import React from 'react';

export default function InfoNiveis({ isOpen, onClose }) {
  // Se a janela não estiver marcada para abrir, não renderiza nada
  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      {/* O stopPropagation evita que o modal feche ao clicar no conteúdo de dentro */}
      <div style={styles.container} onClick={(e) => e.stopPropagation()}>
        {/* Cabeçalho do Modal */}
        <div style={styles.header}>
          <h2 style={styles.title}>🏆 REGRAS DO ESTÁDIO</h2>
          <button onClick={onClose} style={styles.closeButton}>✕</button>
        </div>

        {/* Conteúdo com os Teus Escalões */}
        <div style={styles.content}>
          <p style={styles.intro}>Cada 1 Bola enviada ou recebida equivale a 1 ponto de XP. Sobe de nível para desbloquear o teu prestígio no ecrã!</p>

          {/* Secção Adepto */}
          <h3 style={{ ...styles.sectionTitle, color: '#ff007f' }}>📢 Bancada de Adeptos</h3>
          <ul style={styles.list}>
            <li><strong>Lv. 1-10: Amador (Bronze)</strong> ➔ Cachecol metálico de bronze com luzes suaves de estádio.</li>
            <li><strong>Lv. 11-20: Convocado (Prata)</strong> ➔ Cachecol de prata polida e néon rosa e azul elétrico.</li>
            <li><strong>Lv. 21-35: Titular (Ouro)</strong> ➔ Cachecol de ouro puro com reflexos e néon âmbar.</li>
            <li><strong>Lv. 36-50: Capitão (Diamante)</strong> ➔ Cachecol de cristal de diamante com néon cyan e roxo.</li>
            <li><strong>Lv. 51-70: Lenda (Campeão)</strong> ➔ Cachecol majestoso com fogo néon, raios e coroa imperial.</li>
          </ul>

          {/* Secção Jogador */}
          <h3 style={{ ...styles.sectionTitle, color: '#00ff00' }}>🏃 Balneário de Craques</h3>
          <ul style={styles.list}>
            <li><strong>Lv. 1-10: Amador (Bronze)</strong> ➔ Braçadeira de bronze com néon verde discreto.</li>
            <li><strong>Lv. 11-20: Convocado (Prata)</strong> ➔ Braçadeira de prata com néon rosa e azul gelo.</li>
            <li><strong>Lv. 21-35: Titular (Ouro)</strong> ➔ Braçadeira de ouro puro com brilho néon âmbar.</li>
            <li><strong>Lv. 36-50: Capitão (Diamante)</strong> ➔ Braçadeira de cristal com luz néon cyan.</li>
            <li><strong>Lv. 51-70: Lenda (Campeão)</strong> ➔ Braçadeira lendária envolta em chamas néon e coroa.</li>
          </ul>
        </div>

        {/* Botão de Fechar no Fundo */}
        <button onClick={onClose} style={styles.bottomButton}>VOLTAR AO JOGO ⚽</button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 3000,
  },
  container: {
    backgroundColor: '#121212',
    border: '2px solid #333',
    borderRadius: '16px',
    width: '90%',
    maxWidth: '420px',
    maxHeight: '80vh',
    overflowY: 'auto',
    padding: '20px',
    color: '#fff',
    fontFamily: 'sans-serif',
    boxShadow: '0 0 20px rgba(0,0,0,0.8)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #222',
    paddingBottom: '10px',
    marginBottom: '15px',
  },
  title: {
    margin: 0,
    fontSize: '1.1rem',
    letterSpacing: '1px',
    fontWeight: 'bold',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    color: '#888',
    fontSize: '1.4rem',
    cursor: 'pointer',
  },
  content: {
    textAlign: 'left',
  },
  intro: {
    fontSize: '0.85rem',
    color: '#aaa',
    lineHeight: '1.4',
    marginBottom: '15px',
  },
  sectionTitle: {
    fontSize: '1rem',
    marginTop: '15px',
    marginBottom: '8px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontWeight: 'bold',
  },
  list: {
    listStyleType: 'none',
    paddingLeft: 0,
    fontSize: '0.8rem',
    lineHeight: '1.5',
    color: '#bbb',
    marginBottom: '15px',
  },
  bottomButton: {
    width: '100%',
    backgroundColor: '#121212',
    border: '1px solid #444',
    color: '#fff',
    padding: '12px',
    borderRadius: '8px',
    fontSize: '0.9rem',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: '10px',
    transition: 'all 0.2s ease',
  }
};
